import { Dialog, DialogTitle, Slide } from "@mui/material";
import CrossIcon from "Common/CrossIcon/CrossIcon";
import React from "react";
import styles from './index.module.scss'


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CustomModal = ({ open, handleClose, title, children, maxWidth = "lg", ariaLabelledby = "customized-dialog-title" }, ...props) => {
  return (
    <Dialog
      TransitionComponent={Transition}
      open={open}
      onClose={handleClose}
      maxWidth={maxWidth}
      fullWidth
      aria-labelledby={ariaLabelledby}
    >
      <DialogTitle className={styles.title}>
        {title}
        <CrossIcon
          color={"inherit"}
          onClick={handleClose}
          className={styles.crossIcon}
        />
      </DialogTitle>
      {children}
    </Dialog>
  );
};

export default CustomModal;
